interface Props {
  size: "lg" | "xl";
  children: React.ReactNode;
}

export default function Box({ size, children }: Props) {
  let sizeClass = "";

  switch (size) {
    case "lg":
      sizeClass = "max-w-lg";
      break;
    case "xl":
      sizeClass = "max-w-xl";
      break;
  }
  return (
    <div
      className={`rounded-lg m-auto w-10/12 bg-slate-400 p-lg sm:p-xl ${sizeClass}`}
    >
      {children}
    </div>
  );
}
